import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ResetVariation($id: ID!) {
    resetVariation(id: $id) {
      id
      copyText: acCopyText
      copyTextMarkup
      score
      engagementScoreSupportSize
      isScoreLocked
      performancePredictionsScoreLocked
      ageScoreHistogram
      genderScoreHistogram
    }
  }
`;

export const resetVariation = (id) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { id },
  }).then(({ data }) => getSingleProp(data));
};
